module.exports = __webpack_public_path__ + "static/media/sunset_18.7fb10ae0.webp";